/** @jsxImportSource solid-js */
import { createSignal, createUniqueId, For, type JSX } from "solid-js";

function createRadioInput(
  label: JSX.Element,
  initial: boolean,
  onInput: () => void,
) {
  const id = createUniqueId();
  const [checked, setChecked] = createSignal(initial);
  const [disabled, setDisabled] = createSignal(false);
  return {
    component: (
      <label for={id} class="block mt-2">
        <input
          type="radio"
          id={id}
          class="inline h-4 w-4 rounded-full mr-2 mt-1 text-brand-900 border-brand-300"
          checked={checked()}
          onInput={onInput}
          disabled={disabled()}
        />
        {label}
      </label>
    ),
    disable: (n: boolean) => {
      setDisabled(n);
    },
    setChecked,
  };
}

interface radioOptions {
  label: string;
}

/**
 * Creates a group of radio buttons for the user to select options between.
 */
export function createRadioGroup(
  label: string,
  options: radioOptions[],
  initial: number,
) {
  const [selected, setSelected] = createSignal(initial);
  const theseOptions = options.map((e, i) =>
    createRadioInput(e.label, i === initial, () => {
      setSelected(i);
      theseOptions.map((t, n) => {
        t.setChecked(n === i);
      });
    }),
  );

  return {
    component: (
      <>
        <p class="font-bold mt-4">{label}</p>
        <For each={theseOptions}>{(item) => item.component}</For>
      </>
    ),
    value: () => options[selected()]?.label,
    disable: (n: boolean) => {
      theseOptions.map((e) => {
        e.disable(n);
      });
    },
  };
}
